export default [
  // {
  //   path: '/users/:userId/campaigns/:id/creatives',
  //   name: 'dashboard-campaigns-creatives',
  //   component: () => import('@/views/dashboard/creatives/Creatives.vue'),
  // },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId',
    name: 'dashboard-campaigns-creative-overview',
    component: () => import('@/views/dashboard/creatives/CreativeOverview.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives',
    name: 'dashboard-campaigns-creatives-table',
    component: () => import('@/views/dashboard/creatives/TableCreatives.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives-v2',
    name: 'dashboard-campaigns-creatives-table-v2',
    component: () => import('@/views/dashboard/creatives/TableCreativesV2.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/edit',
    name: 'dashboard-campaigns-creative-edit',
    component: () => import('@/views/dashboard/creatives/FormCreative.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/create',
    name: 'dashboard-campaigns-creative-create',
    component: () => import('@/views/dashboard/creatives/FormNewCreative.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/stats',
    name: 'dashboard-campaigns-creative-stats',
    component: () => import('@/views/dashboard/creatives/Stats.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/v2',
    name: 'dashboard-campaigns-creative-v2',
    component: () => import('@/views/dashboard/creatives/CreativeV2.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/rtb-stats',
    name: 'creatives-rtb-stats-overview',
    component: () => import('@/views/dashboard/creatives/rtb-stats/RtbStatsOverview.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/rtb-stats/sources',
    name: 'creatives-rtb-stats-sources',
    component: () => import('@/views/dashboard/creatives/rtb-stats/RtbStatsSources.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/rtb-stats/partner/:partnerId',
    name: 'creatives-rtb-stats-partner',
    component: () => import('@/views/dashboard/creatives/rtb-stats/RtbStatsPartner.vue'),
  },
  {
    path: '/users/:userId/campaigns/:id/creatives/:bannerId/rtb-stats/partner/:partnerId/source/:sourceId',
    name: 'creatives-rtb-stats-source',
    component: () => import('@/views/dashboard/creatives/rtb-stats/RtbStatsSource.vue'),
  },
]
